import React from "react";
import "react-vis/dist/style.css";
import axios from "axios";
import { Breadcrumb, Row, Col, Tabs, Collapse, message, Button } from "antd";
import { CaretRightOutlined, DownloadOutlined } from "@ant-design/icons";

import DragUpload from "../Form/DragUpload";

const downloadTemplate = async () => {
  try {
    const { data } = await axios({
      url: "api/pnl/template",
      method: "GET",
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "template_pnl-cost-calculation.xlsx");
    document.body.appendChild(link);
    link.click();
  } catch (err) {
    console.log("err", err);
  }
};

const routes = [
  { path: "", breadcrumbName: "App" },
  { path: "/pnl", breadcrumbName: "P&L Cost Calculation" },
];

const Pnl = () => {
  const searchUploadSuccessHandler = (res) => {
    message.info(`Please check your 'System > Jobs' for the upload status.`);
  };

  return (
    <div>
      <div className="header">
        <Row>
          <Col span={12}>
            <h2 className="detail-header-text">P&L Cost Calculation</h2>
          </Col>
          <Col span={12}>
            <Breadcrumb
              style={{ margin: "10px 0", textAlign: "right" }}
              routes={routes}
            />
          </Col>
        </Row>
      </div>

      <Collapse
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
      >
        <Collapse.Panel header="Pnl Cost Calculation" key="pnlSearch">
          <DragUpload
            action={`${process.env.REACT_APP_SERVER_URL}/api/pnl`}
            accept=".xls, .xlsx"
            method="post"
            onUploadSuccess={(res) => searchUploadSuccessHandler(res)}
            additionalDesc={`Excel file with "Tracking Number", "Freight", "COD", "Return", "Insurance", "Additional Charges" and "Courier Weight" columns.`}
          />
          <br />
          <Button onClick={downloadTemplate} className="mt-2">
            <DownloadOutlined /> Template
          </Button>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};

export default Pnl;
